import * as React from 'react';

import { getMonthsOptions } from 'app/components/FormikField/Factory/ValidationFactory';
import { useLocale } from 'app/components/Intl';

import type { RegulationsField } from './RegulationsField.types';
import { RegulationsTextField } from './RegulationsTextField';
import { RegulationsDateField } from './RegulationsDateField';
import { RegulationsSelectField } from './RegulationsSelectField';
import { RegulationsSwitchField } from './RegulationsSwitchField';
import { RegulationsTableField } from './RegulationsTableField';

export type RegulationsFieldInputProps = {
  field: RegulationsField;
  className?: string;
  onChange?: (value: any) => void;
};

const RegulationsFieldInputComponent = ({ field, className, onChange }: RegulationsFieldInputProps) => {
  const locale = useLocale();
  const variant = field.variant;
  let type = field.type ?? 'text';

  if (type === 'text' && field.options?.style === 'select') {
    type = 'select';
  }

  switch (type) {
    case 'select':
    case 'list':
    case 'autocomplete':
      return (
        <RegulationsSelectField
          field={{ ...field, type }}
          className={className}
          variant={variant}
          onChange={onChange}
        />
      );
    case 'month':
      return (
        <RegulationsSelectField
          field={{ ...field, type: 'select', value: `${field.value}`, items: getMonthsOptions(locale) }}
          className={className}
          variant={variant}
          onChange={onChange}
        />
      );
    case 'date':
    case 'dayAndMonth':
      return <RegulationsDateField field={{ ...field, type }} className={className} variant={variant} />;
    case 'checkbox':
    case 'boolean':
      return <RegulationsSwitchField field={field} className={className} />;
    case 'table':
      return <RegulationsTableField field={field} className={className} />;
    default:
      return (
        <RegulationsTextField field={{ ...field, type }} className={className} variant={variant} onChange={onChange} />
      );
  }
};

export const RegulationsFieldInput = React.memo(RegulationsFieldInputComponent);
